<template>
    <div class="ag-cell-wrapper">
        <span>
            <b-button
                class="align-baseline btn-circle-minus"
                title="Remove"
                variant="danger"
                @click="removeItem"
                size="xs"
            >
                <font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon>
            </b-button>
        </span>
    </div>
</template>

<script>
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        methods: {
            removeItem() {
                this.params.deleteItem(this.params.data.id);
            },
        },
    };
</script>
